
<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
    <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>
<div class="app-main flex-column flex-row-fluid" id="kt_app_main">
    <!--begin::Content wrapper-->
    <div class="d-flex flex-column flex-column-fluid">
        <!--begin::Toolbar-->
        <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
            <!--begin::Toolbar container-->
            <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
                <!--begin::Page title-->
                <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                    <!--begin::Title-->
                    <div class="d-flex align-items-center">
                        <h1 class="page-heading">
                            <svg width="44" height="42" viewBox="0 0 44 42" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g filter="url(#filter0_d_855_1927)">
                                    <path
                                        d="M18.721 18.1916L20.1507 16.7613C20.5248 16.3873 20.7305 15.8908 20.7305 15.3617C20.7305 14.8327 20.5248 14.3362 20.1507 13.9622C19.4033 13.2147 18.0997 13.2141 17.3516 13.9622L15.791 15.2429C16.2266 15.8081 16.7043 16.3589 17.2292 16.8837C17.71 17.3645 18.2125 17.791 18.721 18.1916Z"
                                        fill="#265D91" />
                                    <path
                                        d="M19.6724 4.38366C17.4488 3.80213 15.5672 4.13874 14.3734 5.33319C13.1795 6.52703 12.8417 8.40919 13.4238 10.6316C13.7623 11.925 14.3951 13.2479 15.2589 14.5117L16.746 13.2931C17.2575 12.7786 17.982 12.4781 18.7524 12.4781C19.5228 12.4781 20.2473 12.7786 20.7914 13.3227C21.3361 13.8674 21.636 14.5919 21.636 15.3617C21.636 16.1315 21.3355 16.8566 20.7914 17.4007L19.4522 18.7399C21.5051 20.1702 23.6713 20.9484 25.5113 20.9484C26.8197 20.9484 27.9635 20.5587 28.7821 19.7407C31.1795 17.3434 29.8975 12.1614 25.9251 8.189C24.0303 6.29417 21.8097 4.94288 19.6724 4.38306V4.38366Z"
                                        fill="#265D91" />
                                    <path
                                        d="M14.9489 26.2933C14.9489 26.1733 14.9013 26.058 14.8162 25.9736L8.14059 19.298C7.96384 19.1212 7.67729 19.1212 7.50054 19.298L4.71893 22.0796C3.76036 23.0382 3.76036 24.5982 4.71893 25.5567L8.55744 29.3953C9.51601 30.3538 11.076 30.3538 12.0346 29.3953L14.8162 26.6136C14.9013 26.5286 14.9489 26.4128 14.9489 26.2933Z"
                                        fill="#265D91" />
                                    <path
                                        d="M39.7465 0.420861C39.729 0.171113 39.5052 -0.0195155 39.2633 0.00159848L37.2014 0.146983C36.9522 0.164477 36.764 0.381046 36.7821 0.63019C36.7996 0.879938 37.0162 1.06574 37.2653 1.04945L38.2571 0.979475L34.6822 4.38545L32.9484 2.98349C32.7729 2.84112 32.5201 2.85017 32.3554 3.004L28.8077 6.30682C28.6249 6.47694 28.6146 6.76348 28.7847 6.94627C28.9555 7.12966 29.242 7.13871 29.4242 6.96919L32.6842 3.93422L34.4216 5.3386C34.5983 5.48157 34.8535 5.47192 35.0182 5.31447L38.9218 1.5948L38.9888 2.54673C39.0057 2.79648 39.2259 2.98469 39.472 2.96599C39.7212 2.9485 39.9094 2.73193 39.8913 2.48279L39.7465 0.420861Z"
                                        fill="#265D91" />
                                    <path
                                        d="M15.7766 26.9334L13.0366 29.6734L16.7949 33.4317C17.5574 34.1996 18.8182 34.1489 19.5349 33.3448C19.889 32.9907 20.0844 32.5189 20.0844 32.0182C20.0844 31.5175 19.889 31.0458 19.5349 30.6917L15.7766 26.9334Z"
                                        fill="#265D91" />
                                    <path
                                        d="M12.549 10.8602C12.4253 10.3878 12.3518 9.93238 12.3023 9.48718L8.11328 17.9991C8.12173 18.0063 16.1088 25.9675 16.1155 26.0007L24.6159 21.8177C21.9743 21.5275 19.0382 19.9718 16.5908 17.5237C14.5844 15.5167 13.1487 13.1501 12.549 10.8602Z"
                                        fill="#265D91" />
                                </g>
                                <defs>
                                    <filter id="filter0_d_855_1927" x="0" y="0" width="43.8926" height="41.9789"
                                        filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dy="4" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix"
                                            result="effect1_dropShadow_855_1927" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_855_1927"
                                            result="shape" />
                                    </filter>
                                </defs>
                            </svg>

                            Nos appels d’offre
                        </h1>
                        <!--begin::Menu-->
                    </div>
                    <!--end::Title-->
                    <!--begin::Breadcrumb-->
                    <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted">
                            <a routerLink="/accueil" class="text-muted ">Acceuil</a>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item">
                            <span class="bullet bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted">Nos Appels d'offre</li>

                        <li class="breadcrumb-item">
                            <span class="bullet bg-gray-400 w-5px h-2px"></span>
                        </li>

                        <li class="breadcrumb-item text-muted">Liste</li>

                        <!--end::Item-->
                    </ul>
                    <!--end::Breadcrumb-->
                </div>
         
            </div>
            <!--end::Toolbar container-->
        </div>
        <!--end::Toolbar-->
        <div id="kt_app_content" class="app-content flex-column-fluid mb-15">
            <!--begin::Content container-->
            <div id="kt_app_content_container" class="app-container container-fluid">
                <!--begin::Card-->
                <div class="card">
                    <!--begin::Card header-->

                    <div class="card-body" [formGroup]="searchForm">
                        <div class="title mb-10">
                            <h4>Recherche</h4>
                        </div>
                        <div class="row mb-5">
                            <div class="col-lg-6">
                                <div class="input-group search-libre">
                                    <span class="input-group-text">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                            viewBox="0 0 20 20" fill="none">
                                            <path
                                                d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                                                fill="#7E7C7C" />
                                        </svg>
                                    </span>

                                    <input type="text" data-kt-customer-table-filter="search" class="form-control ps-5"
                                        placeholder="Rechercher" formControlName="search" (keyup.enter)="searchOfferr()"/>
                                        <div class="tooltip-container tooltip-info">
                                            <div class="tooltip-trigger"><i class="fa-solid fa-circle-info"
                                                    style="font-size: 20px;"></i></div>
                                            <div class="tooltip-content">
                                                <div class="content">
                                                    <h4>Opérateur AND :</h4>
                                                    <p>Utilisez l'opérateur AND pour spécifier que les résultats doivent
                                                        inclure plusieurs termes.
                                                    </p>
                                                    <p>Exemple : software AND engineer renverra des profils qui
                                                        mentionnent à la fois "software" et "engineer".
                                                    </p>
                                                    <h4>Opérateur OR :</h4>
                                                    <p>Utilisez l'opérateur OR pour spécifier que les résultats peuvent
                                                        inclure l'un des termes.
                                                    </p>
                                                    <p>Exemple : sales OR marketing renverra des profils qui mentionnent
                                                        soit "sales" soit "marketing".
                                                    </p>
                                                    <h4>Opérateur NOT :</h4>
                                                    <p>Utilisez l'opérateur NOT pour exclure des termes spécifiques des
                                                        résultats.
                                                    </p>
                                                    <p>Exemple : developer NOT manager renverra des profils qui
                                                        mentionnent "developer" mais pas "manager".
                                                    </p>
                                                    <h4>Guillemets pour une expression exacte :</h4>
                                                    <p>Utilisez des guillemets pour rechercher une expression exacte.
                                                    </p>
                                                    <p>Exemple : "product manager" renverra des profils qui mentionnent
                                                        exactement "product manager".
                                                    </p>
                                                    <h4>Parenthèses pour grouper des opérations :</h4>
                                                    <p>Utilisez des parenthèses pour définir l'ordre d'évaluation des
                                                        opérations.
                                                    </p>
                                                    <p>Exemple : (sales OR marketing) AND manager renverra des profils
                                                        qui mentionnent "sales" ou "marketing" et "manager".
                                                    </p>
                                                    <h4>Recherche standard :</h4>
                                                    <p>Si aucun opérateur n'est spécifié dans la recherche, le texte
                                                        sera interprété comme s'il était entre guillemets.
                                                    </p>
                                                    <p>Exemple : La recherche product manager sera traitée comme
                                                        "product manager", suivant la règle 4.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>
                        <div class="tools" >

                            <div class="row">
                          
                                <div class="col-lg-3">
                                    <input type="text" class="form-control form-control-solid ps-5  mb-3"
                                        formControlName="ID_jobRequest" name="nom" value="" placeholder=" ID" />

                                </div>
                                <div class="col-lg-3">
                                    <input type="text" class="form-control form-control-solid ps-5 mb-3"
                                        formControlName="name" name="nom" value="" placeholder="Poste" />

                                </div>
                                <div class="col-lg-3">
                                    <div class="combined-input mb-3">
                                
                                        <input type="number" formControlName="years_of_experience"
                                            oninput="validity.valid||(value='0');" min="0" class="form-control mb-3"
                                            placeholder="Années d’expérience"
                                            aria-label="Amount (to the nearest dollar)" class="nb1" />
                                        <input type="number" formControlName="experience_range"
                                            oninput="validity.valid||(value='0');" min="0" class="nb2" value=""
                                            placeholder="marge_Années d’expérience" id="marge_année d’exp">

                                        <div class="plusetmois">
                                            <i class="fa-solid fa-plus-minus"></i>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-lg-3 mb-3">
                            
                                    <ng-select formControlName="contract_type" [items]="contratType" bindLabel="name"
                                        bindValue="id" [placeholder]="'Type de contrat'" [multiple]="true" autoComplete [notFoundText]="'Aucun élément trouvé'">
                                    </ng-select>
                                </div>

                            </div>

                            <div class="row" *ngIf="!isCollapsed">
                                <div class="col-lg-3">
                                    <div class="combined-input mb-3">
                                        <input type="number"  oninput="validity.valid||(value='0');" min="0" name="number1" formControlName="desired_salary" 
                                            class="nb1" placeholder="Salaire" id="Salaire">


                                        <div class="euro">
                                            <svg width="11" height="11" viewBox="0 0 11 11" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                                                    fill="#4B4B4B" />
                                            </svg>
                                        </div>
                                        <input type="number" oninput="validity.valid||(value='0');" min="0" formControlName="desired_salary_range"  (change)="alreadyConverted=false" name="number2" (input)="onSalaryRangeInput($event)"
                                            class="nb2" value="1" id="marge_tjm">
                                        <div class="icon">
                                            <svg width="20" height="15" viewBox="0 0 19 11" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M5.37 10L1.352 5.548V10H0.0780001V0.242H1.352V4.764L5.384 0.242H6.994L2.57 5.128L7.036 10H5.37Z"
                                                    fill="#4B4B4B" />
                                                <path
                                                    d="M13.889 8.739C14.435 8.739 14.9117 8.62633 15.319 8.401C15.735 8.167 16.06 7.82467 16.294 7.374H18.075C17.737 8.24067 17.1953 8.908 16.45 9.376C15.7047 9.844 14.851 10.078 13.889 10.078C12.875 10.078 11.9737 9.805 11.185 9.259C10.3963 8.70433 9.846 7.96767 9.534 7.049H8.338V6.035H9.3C9.28267 5.79233 9.274 5.60167 9.274 5.463C9.274 5.32433 9.28267 5.13367 9.3 4.891H8.338V3.877H9.534C9.846 2.95833 10.3963 2.226 11.185 1.68C11.9737 1.12533 12.875 0.847999 13.889 0.847999C14.8423 0.847999 15.6917 1.08633 16.437 1.563C17.191 2.031 17.737 2.69833 18.075 3.565H16.294C16.06 3.11433 15.735 2.77633 15.319 2.551C14.9117 2.317 14.435 2.2 13.889 2.2C13.2563 2.2 12.6973 2.34733 12.212 2.642C11.7353 2.93667 11.3713 3.34833 11.12 3.877H13.889V4.891H10.834C10.808 5.073 10.795 5.26367 10.795 5.463C10.795 5.66233 10.808 5.853 10.834 6.035H13.889V7.049H11.12C11.3713 7.58633 11.7353 8.00233 12.212 8.297C12.6973 8.59167 13.2563 8.739 13.889 8.739Z"
                                                    fill="#4B4B4B" />
                                            </svg>
                                        </div>
                                        <div class="plusetmois">
                                            <i class="fa-solid fa-plus-minus"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3">
                                    <div class="combined-input mb-3">
                                        <input type="number"  oninput="validity.valid||(value='0');" min="0" name="number1" class="nb1 " placeholder="TJM" id="tjm"
                                            formControlName="tjm">
                                        <div class="euro">
                                            <svg width="11" height="11" viewBox="0 0 11 11" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                                                    fill="#4B4B4B" />
                                            </svg>
                                        </div>
                                        <input type="number"  oninput="validity.valid||(value='0');" min="0" name="number2" class="nb2" value="1" id="marge_tjm"
                                            formControlName="tjm_range">
                                        <div class="icon">
                                            <svg width="11" height="11" viewBox="0 0 11 11" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                                                    fill="#4B4B4B" />
                                            </svg>
                                        </div>
                                        <div class="plusetmois">
                                            <i class="fa-solid fa-plus-minus"></i>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 ">
                                    <ng-select formControlName="post_type" [multiple]="true" [items]="postType" class="mb-3"
                                        bindLabel="name" bindValue="id" [placeholder]="'Type de poste'" [notFoundText]="'Aucun élément trouvé'" autoComplete>
                                    </ng-select>

                                </div>

                                <div class="col-lg-3">
                                    <ng-select [items]="skillsList"  bindLabel="name_FR"
                                        formControlName="skillsAnd" bindValue="name_FR" [multiple]="true" class="mb-3"
                                        placeholder="Compétences (et)" [notFoundText]="'Aucun élément trouvé'" autoComplete>
                                    </ng-select>


                                </div>

                            </div>
                            <div class="row" *ngIf="!isCollapsed">
                                <div class="col-lg-3">
                                    <ng-select [items]="skillsList" class=" mb-3"
                                        bindLabel="name_FR" bindValue="name_FR" formControlName="skillsOr"
                                        [multiple]="true" [placeholder]="'Compétences (ou)'" [notFoundText]="'Aucun élément trouvé'" autoComplete>
                                    </ng-select>
                                </div>
                                <div class="col-lg-3">
                                    <ng-select formControlName="availability" [multiple]="true" [items]="disponibilite"
                                        bindLabel="name" class=" mb-3" bindValue="id" [placeholder]="'Disponibilité'"
                                        autoComplete [notFoundText]="'Aucun élément trouvé'">
                                    </ng-select>
                                </div>
                                <div class="col-lg-3">
                                    <ng-select (change)="onCountryChange('add')" [items]="paysList" [multiple]="true"
                                        bindLabel="name" formControlName="country" bindValue="name" class=" mb-3"
                                        [placeholder]="'Pays'"  [notFoundText]="'Aucun élément trouvé'"autoComplete>
                                    </ng-select>
                                </div>
                                <div class="col-lg-3">
                                    <ng-select [items]="stateList" [ngClass]="{'disable-select':!stateList?.length}" [attr.disabled]="!stateList?.length ? true : null" bindLabel="name" [multiple]="true"  (change)="onMobilityChange('add')"
                                        [multiple]="true" class=" mb-3" formControlName="city" bindValue="name"
                                        [placeholder]="'Ville'" [notFoundText]="'Aucun élément trouvé'" autoComplete>
                                    </ng-select>
                                </div>



                            </div>
                            <div class="row" *ngIf="!isCollapsed">
                                <div class="col-lg-3">
                                    <div class="position-relative d-flex align-items-center calenderDate">
                                        <!--begin::Datepicker-->
                                      
                                        <!--end::Datepicker-->
                                        <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy" 
                                         placeholder="Date de début de publication" inputId="yearpicker"
                                         formControlName="start_date" class="form-control"
                                         ></p-calendar>
                  
                                    </div>
                                </div>
                                <div class="col-lg-3">
                                    <div class="position-relative d-flex align-items-center calenderDate">
                                        <!--begin::Datepicker-->
                                   

                                        <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy" 
                                         placeholder="Date de fin de publication" inputId="yearpicker"
                                         formControlName="end_date" class="form-control"
                                         ></p-calendar>

                                         
                                        <!--end::Datepicker-->
                                    </div>
                                </div>
                                <div class="col-lg-3">
                                    <ng-select  [items]="profile" bindLabel="name"
                                        class=" mb-3" bindValue="id" [placeholder]="'Profil à l\'étranger'"
                                        formControlName="profile_abroad" autoComplete [notFoundText]="'Aucun élément trouvé'">
                                    </ng-select>
                                </div>
                                <div class="col-lg-3">
                                    <ng-select  [items]="passeport" bindLabel="name"
                                        class=" mb-3" bindValue="id" [placeholder]="'Passeport talent'"
                                        formControlName="passeport_talent" autoComplete [notFoundText]="'Aucun élément trouvé'">
                                    </ng-select>
                                </div>
                                <div class="col-lg-3 mb-3">
                                    <ng-select [multiple]="true" [items]="Statut" bindLabel="name"
                                        formControlName="state" bindValue="id" [placeholder]="'Statut'" autoComplete [notFoundText]="'Aucun élément trouvé'"> 
                                    </ng-select>
                                </div>

                                <div class="col-lg-3"></div>
                                <div class="col-lg-3 ">

                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 mb-3"></div>
                                <div class="col-lg-3 mb-3"></div>
                                <div class="col-lg-3 mb-3"></div>
                                <div class="col-lg-3 mb-3 mt-2 seemore">
                                    <a [ngClass]="{'show-more-button': !isCollapsed, 'emphasized-button': isCollapsed}"
                                        (click)="toggleCollapsible()" class="show-more-button">
                                        {{ isCollapsed ? 'Voir plus de critères de recherche' : 'Voir moins' }}
                                    </a>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-3"></div>
                                <div class="col-lg-3"></div>
                                <div class="col-lg-3"></div>
                                <div class="mb-3 search-btn d-flex justify-content-end">

                                    <div class="align-items-center recherche">
                                        <button type="button" class="me-5" (click)="searchOfferr()">
                                            <svg width="15" height="15" viewBox="0 0 20 20" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                                                    fill="white" />
                                            </svg>
                                            Rechercher</button>
                                    </div>
                                    <div class="resett-btn">
                                        <div class="reset-icon cursor-pointer" data-bs-toggle="tooltip"
                                            data-bs-placement="top" title="Réinitialiser">
                                            <a (click)="reset()"> <img src="/assets/media/icons/reset.png" alt=""
                                                    width="30px"></a>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <!--end::Content container-->
        </div>
        <!--begin::Content-->
        <div *ngIf="!isLoadSpinner" id="kt_app_content" class="app-content flex-column-fluid mb-4">
            <!--begin::Content container-->
            <div id="kt_app_content_container" class="app-container container-fluid">
                <!--begin::Card-->
                <div class="card">
                    <!--begin::Card header-->
                    <div class="table-header">
                        <div class="section_title">
                            <h1 class="section-heading my-10">Liste des appels d’offres</h1>
                        </div>
                        <div class="add">
                          
                            <a routerLink="/ajout-appel">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M11.4758 18.5502L8.44445 10.1374C8.3936 9.99568 8.3859 9.84199 8.42233 9.69585C8.45877 9.54972 8.53768 9.41773 8.64906 9.31666L10.4224 7.53834C10.4123 7.30564 10.4731 7.07538 10.5967 6.87816C10.7203 6.68093 10.9008 6.52609 11.1142 6.43421C11.3276 6.34232 11.5639 6.31775 11.7916 6.36374C12.0193 6.40974 12.2276 6.52413 12.389 6.69171C12.5503 6.8593 12.6569 7.07214 12.6947 7.30196C12.7325 7.53178 12.6997 7.76769 12.6006 7.97835C12.5014 8.189 12.3408 8.36443 12.1398 8.48131C11.9389 8.59819 11.7073 8.65099 11.4758 8.6327L10.0359 10.0766L12.173 16.012L17.0382 1.9754L3.04112 6.85438L6.26948 7.99432C6.46242 8.06588 6.61913 8.21136 6.70511 8.39878C6.79109 8.58619 6.79931 8.80019 6.72796 8.99368C6.65661 9.18717 6.51153 9.34432 6.32465 9.43054C6.13776 9.51677 5.92437 9.52501 5.73142 9.45346L0.509966 7.56114C0.36106 7.50946 0.231921 7.41252 0.140519 7.2838C0.049118 7.15508 0 7.00099 0 6.84298C0 6.68496 0.049118 6.53087 0.140519 6.40216C0.231921 6.27344 0.36106 6.17649 0.509966 6.12481L18.0007 0.0450919C18.136 -0.00387194 18.2825 -0.013182 18.4229 0.0182501C18.5634 0.0496822 18.692 0.120557 18.7937 0.222589C18.8955 0.32462 18.9661 0.45359 18.9975 0.594419C19.0288 0.735247 19.0195 0.882115 18.9707 1.01785L12.9081 18.5578C12.8557 18.7069 12.7584 18.8359 12.6296 18.9269C12.5007 19.0179 12.3468 19.0663 12.1892 19.0655C12.0316 19.0646 11.8782 19.0146 11.7504 18.9222C11.6225 18.8299 11.5265 18.6998 11.4758 18.5502Z"
                                        fill="white" />
                                </svg>
                                Publier</a>
                        </div>
                        <!--begin::Tab nav-->

                        <!--end::Tab nav-->
                        <!--begin::Wrapper-->

                        <!--end::Wrapper-->
                    </div>
                    <div class="grid-list">
                        <ul class="nav nav-pills me-5">
                            <li class="nav-item m-0">
                                <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary me-3"
                                    data-bs-toggle="tab" href="#kt_project_targets_card_pane">
                                    <i class="ki-duotone ki-element-plus fs-1">
                                        <span class="path1"></span>
                                        <span class="path2"></span>
                                        <span class="path3"></span>
                                        <span class="path4"></span>
                                        <span class="path5"></span>
                                    </i>
                                </a>
                            </li>
                            <li class="nav-item m-0">
                                <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary active"
                                    data-bs-toggle="tab" href="#kt_project_targets_table_pane">
                                    <i class="ki-duotone ki-row-horizontal fs-2">
                                        <span class="path1"></span>
                                        <span class="path2"></span>
                                    </i>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <!--end::Card header-->
                    <!--begin::Card body-->
                    <div class="card-body">
                        <div class="tab-content for-web">
                            <!--begin::Tab pane-->
                            <div id="kt_project_targets_card_pane" class="tab-pane fade">
                                <!--begin::Row-->
                                <div class="row g-6 g-xl-9 justify-content-center">
                                    <!--begin::Col-->
                                    <div class="col-md-6 col-xxl-4" *ngFor="let call of listCallOffers ; let i =index">
                                        <!--begin::Card-->
                                        <div class="card pt-5 p-5">
                                            <div class="status">
                                                <span class="actif" *ngIf="call.state==0">
                                                    <i class="fa-solid fa-circle"></i> Actif
                                                </span>
                                                <span class="badge desactif" *ngIf="call.state==1"> <i
                                                        class="fa-solid fa-circle"></i> Non Actif</span>
                                            </div>

                                            <div class="tools">
                                                <div class="dropdown">
                                                    <button
                                                        class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                                        type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
                                                        aria-haspopup="true" aria-expanded="false">
                                                        <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                transform="matrix(1 0 0 -1 0 4.89478)" fill="#265D91" />
                                                            <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                                fill="#265D91" />
                                                            <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                                fill="#265D91" />
                                                        </svg>
                                                    </button>
                                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                        <a class="dropdown-item "
                                                             routerLink="/detail-offre/{{call.id}}"
                                                            style="cursor: pointer;">Voir
                                                            Détail</a>

                                                        <a class="dropdown-item" (click)="openModal(modify_appel,call)"
                                                            style="cursor: pointer;">
                                                            Modifier
                                                        </a>
                                                       
                                                        <a class="dropdown-item"  routerLink="/candidature-appel-offre/{{call.id}}"
                                                            style="cursor: pointer;">Liste
                                                            des candidatures </a>

                                                        <a class="dropdown-item"
                                                        (click)="navigateToAddBareme(call.id)"
                                                            style="cursor: pointer;">Voir barème </a>
                                                          <a class="dropdown-item"
                                                                style="cursor: pointer;" routerLink="/suggestion-call-offer/{{call.id}}">suggestion</a>
                                                        <a class="dropdown-item"
                                                        routerLink="/list-esn-call-offer/{{call.id}}"
                                                                    style="cursor: pointer;">Qui a visualiser
                                                                    cette offre </a>
                                                
                                                                    <a *ngIf="call.state==1" class="dropdown-item cursor-pointer"
                                                                    (click)="activerjoboffer(call.id)">Activer</a>
                                                                <a *ngIf="call.state==0" class="dropdown-item cursor-pointer"
                                                                    (click)="desactiverjoboffer(call.id)">Désactiver</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <!--begin::Card body-->
                                            <div class="card-body d-flex flex-center flex-column">
                                         
                                                <div class="symbol symbol-65px symbol-circle mb-5">
                                                  
                                                    <img *ngIf="call.image_url && call.image_url!='avatar.png'"
                                                        class="table-img" src="{{urlimage + call.image_url}}" alt=""
                                                        width="50px">
                                                    <img *ngIf="call.image_url && call.image_url=='avatar.png'"
                                                        class="table-img" src="/assets/media/icons/avatar.jpg" alt=""
                                                        width="50px">
                                                    <img *ngIf="!call.image_url || call.image_url===undefined"
                                                        class="table-img" src="/assets/media/icons/avatar.jpg" alt=""
                                                        width="50px">

                                                   
                                                </div>
                                                <!--end::Avatar-->
                                                <!--begin::Name-->
                                                <a class="fs-4 text-gray-800 fw-bold mb-0">
                                                    Entreprise : {{call.name}}

                                                </a>

                                                <div class="content-card">
                                                    <!--begin::Stats-->
                                                    <div class="info">
                                                        <div class="py-3 px-4" *ngIf="call.tjm && call.tjm !== '0'">
                                                            <div class="badge-annee"> <span>Tjm :</span> 
                                                                <span >{{call.tjm + ' &euro;'}}</span>

                                                            </div>
                                                        </div>

                                                        <div class="py-3 px-4" *ngIf="call.salary && call.salary !== '0'">
                                                            <div class="badge-annee"> <span>Salaire :</span>
                                                                <span >{{call.salary + ' &euro;'}}</span>

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="text-center">
                                                        <div class="py-3 px-4" *ngIf="call.years_of_experience && call.years_of_experience !== '0 ans'">
                                                            <div class="badge-annee"> <span>ANS.EXP :</span>
                                                                <span >
                                                                    {{call.years_of_experience}} ans
                                                                  </span></div>
                                                        </div>

                                                    </div>
                                                    <!--end::Stats-->
                                                    <!--begin::Stats-->


                                                    <!--end::Stats-->
                                                </div>


                                                <!--end::Info-->
                                            </div>
                                            <div class="foot p-5">
                                               
                                                    <div *ngFor="let contractType of call.contract_type">
                                                        <span class="color-blue">{{ contratTypeOptions[contractType] }}</span>
                                                      
                                                    </div>
                                                  
                                                    <span *ngIf="call.contract_type===null">---</span>
                                                 
                                               




                                                <div class="plus">
                                                    <a style="cursor: pointer;"
                                                         routerLink="/detail-offre-clientfinal/{{call.id}}">voir plus </a>

                                                </div>
                                            </div>
                                            <!--end::Card body-->
                                        </div>
                                        <!--end::Card-->
                                    </div>
                                    <!--end::Col-->


                                </div>
                                <!--end::Row-->
                            </div>
                            <!--end::Tab pane-->
                            <!--begin::Tab pane-->
                            <div id="kt_project_targets_table_pane" class="tab-pane fade show active">
                                <div class="content">
                                    <!--begin::Card header-->

                                    <!--end::Card header-->
                                    <!--begin::Card body-->
                                    <div class="card-body">
                                        <!--begin::Table-->
                                        <div class="table-responsive"   id="kt_customers_table">
                                            <table class="table align-middle gy-5 style-table"
                                              >
                                                <thead>
                                                    <tr class="text-start text-gray-400 fw-bold text-uppercase gs-0">
                                                        <ng-container *ngFor="let item of listNames ;let i =index">
                                                            <th class="min-w-175px" [ngClass]="{'th-fixed': item === 'Poste'}">
                                                              <span>{{item}}</span>
                                                              <i *ngIf="!['Logo'].includes(item) && !['Compétences'].includes(item)" (click)="sortData(item)"
                                                                class="fa-solid fa-sort cursor-pointer"></i>
                                                            </th>
                                                          </ng-container>
                                                        <th class="text-end min-w-70px"><span>Actions</span></th>
                                                        <th class="min-w-70px">
                                                            <div class="dropdown">
                                                              <button
                                                                class="dropdown-toggle"
                                                                type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28"
                                                                  fill="none">
                                                                  <g filter="url(#filter0_d_588_1699)">
                                                                    <rect x="4" width="20" height="20" rx="4" fill="#63C3E8" fill-opacity="0.12"
                                                                      shape-rendering="crispEdges" />
                                                                  </g>
                                                                  <path
                                                                    d="M17.5 10.6H14.6V13.5C14.6 13.8314 14.3314 14.1 14 14.1C13.6686 14.1 13.4 13.8314 13.4 13.5V10.6H10.5C10.1686 10.6 9.9 10.3314 9.9 10C9.9 9.66863 10.1686 9.4 10.5 9.4H13.4V6.5C13.4 6.16863 13.6686 5.9 14 5.9C14.3314 5.9 14.6 6.16863 14.6 6.5V9.4H17.5C17.8314 9.4 18.1 9.66863 18.1 10C18.1 10.3314 17.8314 10.6 17.5 10.6Z"
                                                                    fill="#265D91" stroke="#265D91" stroke-width="0.2" />
                                                                  <defs>
                                                                    <filter id="filter0_d_588_1699" x="0" y="0" width="28" height="28"
                                                                      filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                                      <feColorMatrix in="SourceAlpha" type="matrix"
                                                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                                                      <feOffset dy="4" />
                                                                      <feGaussianBlur stdDeviation="2" />
                                                                      <feComposite in2="hardAlpha" operator="out" />
                                                                      <feColorMatrix type="matrix"
                                                                        values="0 0 0 0 0.14902 0 0 0 0 0.364706 0 0 0 0 0.568627 0 0 0 0.13 0" />
                                                                      <feBlend mode="normal" in2="BackgroundImageFix"
                                                                        result="effect1_dropShadow_588_1699" />
                                                                      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_588_1699"
                                                                        result="shape" />
                                                                    </filter>
                                                                  </defs>
                                                                </svg>
                                                              </button>
                                                             <div class="dropdown-table">
                                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                    <div class="d-flex checkbox mb-2 menu" *ngFor="let item of dataHeader;let i =index">
                                                                      <div class="form-check form-check-sm form-check-custom form-check-solid"
                                                                        *ngIf="item.name!='checkbox'">
                                  
                                                                        <input class="form-check-input checkbox-border"
                                                                        [checked]="(item.checked=='oui'&&!item.checked_user)||item.checked_user=='oui'&&(item.checked=='non'||item.checked=='oui')"
                                                                        (change)="changeSelection($event,item,i)" type="checkbox" value="1" />
                                                                        <a class="dropdown-item">{{item.name}}</a>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                             </div>
                              
                                                            </div>
                                                          </th>
                                                    </tr>
                                                </thead>
                                                <tbody class="fw-semibold text-gray-600">
                                                    <tr *ngFor="let call of listCallOffers ;let i=index">
                                                        <td *ngIf="listNames.includes('ID')"><a routerLink="detail-offre-clientfinal/{{call.id}}"
                                                                 routerLink="/detail-offre-clientfinal/{{call.id}}"><span class="first-td">{{call.ID_jobRequest}}</span></a>
                                                        </td>
                                                        <td *ngIf="listNames.includes('Poste')" class="td-fixed"><a class="first-td"
                                                                 routerLink="/detail-offre-clientfinal/{{call.id}}">{{call.name}}</a>
                                                                 <!-- routerLink="/detail-offre-clientfinal/{{call.id}}">{{call.name}}</a> -->
                                                        </td>
                                                        <td *ngIf="listNames.includes('Date de publication')">
                                                            <span>
                                                                {{ !call.start_date ? '---' : call.start_date.split('
                                                                ')[0].split('-').reverse().join('/') }}
                                                            </span>
                                                        </td>
                                                        <td *ngIf="listNames.includes('Années d’expérience')">
                                                            <span *ngIf="call.years_of_experience!=='0 ans'">{{call.years_of_experience}} ans</span>
                                                            <span *ngIf="call.years_of_experience==='0 ans'">---</span>
                                                        </td>
                                                        <td *ngIf="listNames.includes('Type de contrat')">
                                                            <div *ngFor="let contractType of call.contract_type">
                                                                <span>{{
                                                                    contratTypeOptions[contractType] }}</span>
                                                            </div>
                                                            <!-- *ngIf="call.contract_type?.length===0" -->
                                                            <span   *ngIf="call.contract_type===null || call?.contract_type?.length===0">---</span> 
                                                        </td>
                                                        <td *ngIf="listNames.includes('Salaire')">
                                                            <span *ngIf="call.salary && call.salary!==null && call.salary!=='null'&& call.salary!=='0'">{{ call.salary +'&euro;'}}</span>
                                                            <span *ngIf="!call.salary || call.salary===null || call.salary==='null'||call.salary==='0'">---</span>
                                                        </td>
                                                        <td *ngIf="listNames.includes('TJM')">
                                                            <span *ngIf="call.tjm  && call.tjm!==null && call.tjm!=='null'&& call.tjm!=='0'">{{call.tjm + '&euro;'}}</span>
                                                            <span *ngIf="!call.tjm || call.tjm===null || call.tjm==='null'||call.tjm==='0'">---</span>
                                                        </td>
                                                        <td *ngIf="listNames.includes('Type de poste')">
                                                       
                                                            <span *ngIf="call.post_type==1"
                                                                class="badge badge-type hybride-badge">A distance</span>
                                                            <span *ngIf="call.post_type==2"
                                                                class="badge badge-type sur-site-badge">Hybride</span>
                                                            <span *ngIf="call.post_type==3"
                                                                class="badge badge-type teletravail-badge">Sur site</span>
                                                                <span *ngIf="call.post_type===null">---</span>
                                                             
                                                        </td>
                                                        <td *ngIf="listNames.includes('Compétences')">
                                                            <div class="skills">
                                                                <ng-container
                                                                    *ngFor="let skill of call.skills_job.slice(0,2)">
                                                                    <span>
                                                                        <div class="php">
                                                                            {{skill?.sub_category?.name_FR?skill?.sub_category?.name_FR:'---'}}
                                                                        </div>
                                                                    </span>
                                  

                                                                </ng-container>
                                                                <span
                                                                    *ngIf="call.skills_job?.length&&call.skills_job?.length>2"><svg
                                                                        width="8" height="8" viewBox="0 0 8 8"
                                                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path
                                                                            d="M7.34144 4.86849H4.51344V7.76649H3.02944V4.86849H0.201438V3.52449H3.02944V0.626487H4.51344V3.52449H7.34144V4.86849Z"
                                                                            fill="#ACA7A7" />
                                                                    </svg>
                                                                </span>
                                                            </div>
                                                            <span *ngIf="call.skills_job.length==0">---</span>
                                                        </td>
                                                        <!-- <td class="cle" *ngIf="!call.skills_job?.length">
                                                            <span class="key-word">
                                                                <div class="php"><svg width="6" height="6"
                                                                        viewBox="0 0 6 6" fill="none">
                                                                    </svg>---</div>
                                                            </span>
                                                        </td> -->


                                                        <td *ngIf="listNames.includes('Disponibilité')"><span class="color-blue">{{
                                                                availabilituyTypeOptions[call.availability] }}</span>
                                                                  <span *ngIf="call.availability===null">---</span>
                                                        </td>

                                                        <td *ngIf="listNames.includes('Pays')">
                                                            <span>{{call.country}}</span>
                                                            <span *ngIf="call?.country?.length==0 || call.country==null">---</span>
                                                        </td>
                                                        <td *ngIf="listNames.includes('Ville')">
                                                            <span *ngIf="call.city">{{call.city}}</span>
                                                            <span *ngIf="call.city==null ||  call?.city?.length==0">---</span></td>




                                                        <td   *ngIf="call.state === 0 && listNames.includes('Statut')">
                                                            <span class="actif">
                                                                <i class="fa-solid fa-circle"></i> Actif
                                                            </span>
                                                        </td>
                                                        <td *ngIf="call.state === 1 && listNames.includes('Statut')">
                                                            <span class="badge desactif"> <i
                                                                    class="fa-solid fa-circle"></i> Non Actif</span>
                                                  
                                                        </td>
                                                        <td class="actions">
                                                            <div class="tools">
                                                                <div class="dropdown">
                                                                    <button
                                                                        class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                                                        type="button" id="dropdownMenuButton"
                                                                        data-bs-toggle="dropdown" aria-haspopup="true"
                                                                        aria-expanded="false">
                                                                        <svg width="19" height="5" viewBox="0 0 19 5"
                                                                            fill="none"
                                                                            xmlns="http://www.w3.org/2000/svg">
                                                                            <circle cx="2.44739" cy="2.44739"
                                                                                r="2.44739"
                                                                                transform="matrix(1 0 0 -1 0 4.89478)"
                                                                                fill="#265D91" />
                                                                            <circle cx="2.44739" cy="2.44739"
                                                                                r="2.44739"
                                                                                transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                                                fill="#265D91" />
                                                                            <circle cx="2.44739" cy="2.44739"
                                                                                r="2.44739"
                                                                                transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                                                fill="#265D91" />
                                                                        </svg>
                                                                    </button>
                                                                    <div class="dropdown-menu"
                                                                        aria-labelledby="dropdownMenuButton">
                                                                        <a class="dropdown-item "
                                                                             routerLink="/detail-offre-clientfinal/{{call.id}}"
                                                                            style="cursor: pointer;">Voir
                                                                            Détail</a>

                                                                        <a class="dropdown-item"
                                                                            (click)="openModal(modify_appel,call)"
                                                                            style="cursor: pointer;">
                                                                            Modifier
                                                                        </a>
                                                        

                                                                        <a class="dropdown-item"
                                                                            style="cursor: pointer;"
                                                                            routerLink="/candidature-appel-offre/{{call.id}}">Liste
                                                                            des candidatures</a>
                                                                        <a class="dropdown-item" (click)="navigateToAddBareme(call.id)"
                                                                            style="cursor: pointer;">Voir barème </a>
                                                                        <a class="dropdown-item"
                                                                            style="cursor: pointer;" routerLink="/suggestion-call-offer/{{call.id}}">suggestion </a>
                                                                        <a class="dropdown-item"
                                                                            style="cursor: pointer;" routerLink="/list-esn-call-offer/{{call.id}}">Qui a visualiser
                                                                            cette offre </a>
                                                                            <a *ngIf="call.state==1" class="dropdown-item cursor-pointer"
                                                                            (click)="activerjoboffer(call.id)">Activer</a>
                                                                        <a *ngIf="call.state==0" class="dropdown-item cursor-pointer"
                                                                            (click)="desactiverjoboffer(call.id)">Désactiver</a>


                                                                    </div>
                                                                </div>






                                                            </div>
                                                        </td>
                                                    </tr>

                                                </tbody>
                                            </table>

                                            <!--end::Table-->
                                        </div>


                                        <!--end::Card body-->
                                    </div>
                                    <div class="alert alert-warning text-center mt-5" role="alert"
                                        *ngIf="listCallOffers && !listCallOffers.length">
                                        <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
                                        <span class="empty-list">
                                            La liste est vide
                                        </span>
                                    </div>
                                </div>

                                <!--end::Tab pane-->
                            </div>

                            <!--end::Table-->
                        </div>
                        <div class="tab-content for-mobile">
                            <!--begin::Tab pane-->
                            <div id="kt_project_targets_card_pane" class="tab-pane fade show active">
                                <!--begin::Row-->
                                <div class="row g-6 g-xl-9 justify-content-center">
                                    <!--begin::Col-->
                                    <div class="col-md-6 col-xxl-4" *ngFor="let call of listCallOffers ; let i =index">
                                        <!--begin::Card-->
                                        <div class="card pt-5 p-5">
                                            <div class="status">
                                                <span class="actif" *ngIf="call.state==0">
                                                    <i class="fa-solid fa-circle"></i> Actif
                                                </span>
                                                <span class="badge desactif" *ngIf="call.state==1"> <i
                                                        class="fa-solid fa-circle"></i> Non Actif</span>
                                            </div>

                                            <div class="tools">
                                                <div class="dropdown">
                                                    <button
                                                        class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                                        type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
                                                        aria-haspopup="true" aria-expanded="false">
                                                        <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                transform="matrix(1 0 0 -1 0 4.89478)" fill="#265D91" />
                                                            <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                                fill="#265D91" />
                                                            <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                                fill="#265D91" />
                                                        </svg>
                                                    </button>
                                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                        <a class="dropdown-item "
                                                             routerLink="/detail-offre/{{call.id}}"
                                                            style="cursor: pointer;">Voir
                                                            Détail</a>

                                                        <a class="dropdown-item" (click)="openModal(modify_appel,call)"
                                                            style="cursor: pointer;">
                                                            Modifier
                                                        </a>
                                                        <a class="dropdown-item"  routerLink="/candidature-appel-offre/{{call.id}}"
                                                            style="cursor: pointer;">Liste
                                                            des candidatures </a>

                                                        <a class="dropdown-item"
                                                        (click)="navigateToAddBareme(call.id)"
                                                            style="cursor: pointer;">Voir barème </a>
                                                          <a class="dropdown-item"
                                                                style="cursor: pointer;" routerLink="/suggestion-call-offer/{{call.id}}">suggestion</a>
                                                        <a class="dropdown-item"
                                                        routerLink="list-esn-call-offer/{{call.id}}"
                                                                    style="cursor: pointer;">Qui a visualiser
                                                                    cette offre </a>
                                                                    <a *ngIf="call.state==1" class="dropdown-item cursor-pointer"
                                                                    (click)="activerjoboffer(call.id)">Activer</a>
                                                                <a *ngIf="call.state==0" class="dropdown-item cursor-pointer"
                                                                    (click)="desactiverjoboffer(call.id)">Désactiver</a>
                                                    </div>
                                                </div>
                                            </div>

                                            <!--begin::Card body-->
                                            <div class="card-body d-flex flex-center flex-column">
                                      
                                                <div class="symbol symbol-65px symbol-circle mb-5">
                                                   
                                                    <img *ngIf="call.image_url && call.image_url!='avatar.png'"
                                                        class="table-img" src="{{urlimage + call.image_url}}" alt=""
                                                        width="50px">
                                                    <img *ngIf="call.image_url && call.image_url=='avatar.png'"
                                                        class="table-img" src="/assets/media/avatar.png" alt=""
                                                        width="50px">
                                                    <img *ngIf="!call.image_url || call.image_url===undefined"
                                                        class="table-img" src="/assets/media/avatar.png" alt=""
                                                        width="50px">

                                                   
                                                </div>
                                                <!--end::Avatar-->
                                                <!--begin::Name-->
                                                <a class="fs-4 text-gray-800 fw-bold mb-0">
                                                   {{call.name}}

                                                </a>

                                                <div class="content-card">
                                                    <!--begin::Stats-->
                                                    <div class="info">
                                                        <div class="py-3 px-4">
                                                            <div class="badge-annee"> <span>Tjm :</span> {{call.tjm ?
                                                                call.tjm + ' &euro;' : '---'}} </div>
                                                        </div>

                                                        <div class="py-3 px-4">
                                                            <div class="badge-annee"> <span>Salaire :</span>
                                                                {{call.salary ? call.salary + ' &euro;' :'---'}}</div>
                                                        </div>
                                                    </div>
                                                    <div class="text-center">
                                                        <div class="py-3 px-4">
                                                            <div class="badge-annee"> <span>ANS.EXP :</span>
                                                                {{call.years_of_experience ? call.years_of_experience :
                                                                '---'}} </div>
                                                        </div>

                                                    </div>
                                                    <!--end::Stats-->
                                                    <!--begin::Stats-->


                                                    <!--end::Stats-->
                                                </div>


                                                <!--end::Info-->
                                            </div>
                                            <div class="foot p-5">
                                                <div class="types py-3 px-4 mx-2">
                                                    <div *ngFor="let contractType of call.contract_type">
                                                        <span class="color-blue">{{ contratTypeOptions[contractType] }}</span>
                                                      
                                                    </div>
                                                    <!-- <span *ngIf="call.contract_type.length===0">---</span> -->
                                                    <!-- <ng-container *ngIf="call.contract_type && call.contract_type.length > 0; else noContract">
                                                        <ng-container *ngFor="let contract of call.contract_type">
                                                            <div class="badge-annee" *ngIf="contract === 1">CDD</div>&nbsp;
                                                            <div class="badge-annee" *ngIf="contract === 2">CDI</div>&nbsp;
                                                            <div class="badge-annee" *ngIf="contract === 3">Portage salarial</div>&nbsp;
                                                            <div class="badge-annee" *ngIf="contract === 4">Freelance</div>&nbsp;
                                                            <div class="badge-annee" *ngIf="contract === 5">Stage</div>&nbsp;
                                                            <div class="badge-annee" *ngIf="contract === 6">Alternance</div>&nbsp;
                                                            <div class="badge-annee" *ngIf="contract === 7">Autres type de contrat</div>
                                                            
                                                            &nbsp;
                                                        </ng-container>
                                                    </ng-container> -->
                                                    <!-- <ng-template #noContract >
                                                        <div class="badge-annee" >---</div>
                                                    </ng-template> -->
                                                </div>




                                                <div class="plus">
                                                    <a style="cursor: pointer;"
                                                         routerLink="/detail-offre/{{call.id}}">voir plus </a>

                                                </div>
                                            </div>
                                            <!--end::Card body-->
                                        </div>
                                        <!--end::Card-->
                                    </div>
                                    <!--end::Col-->


                                </div>
                                <!--end::Row-->
                            </div>
                            <!--end::Tab pane-->
                            <!--begin::Tab pane-->
                            <div id="kt_project_targets_table_pane" class="tab-pane fade ">
                                <div class="content">
                                    <!--begin::Card header-->

                                    <!--end::Card header-->
                                    <!--begin::Card body-->
                                    <div class="card-body">
                                        <!--begin::Table-->
                                        <div class="table-responsive">
                                            <table class="table align-middle fs-6 gy-5 style-table"
                                                id="kt_customers_table">
                                                <thead>
                                                    <tr
                                                        class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                                        <th class="min-w-125px"><span>ID <i
                                                                    class="fa-solid fa-sort"></i> </span></th>
                                                        <th class="min-w-125px"><span>Poste <i
                                                                    (click)="sortData('post_type')"
                                                                    class="fa-solid fa-sort"></i></span></th>
                                                        <th class="min-w-175px"><span>Date de publication<i
                                                                    (click)="sortData('updated_at')"
                                                                    class="fa-solid fa-sort"></i></span></th>
                                                        <th class="min-w-175px"><span>Années d’expérience<i
                                                                    (click)="sortData('years_of_experience')"
                                                                    class="fa-solid fa-sort"></i></span></th>
                                                        <th class="min-w-125px"><span>Type de contrat<i
                                                                    (click)="sortData('contract_type')"
                                                                    class="fa-solid fa-sort"></i></span></th>
                                                        <th class="min-w-125px"><span>Salaire<i
                                                                    (click)="sortData('salary')"
                                                                    class="fa-solid fa-sort"></i></span></th>
                                                        <th class="min-w-125px"><span>TJM<i (click)="sortData('tjm')"
                                                                    class="fa-solid fa-sort"></i></span></th>
                                                        <th class="min-w-125px"><span>Type de poste<i
                                                                    (click)="sortData('tjm')"
                                                                    class="fa-solid fa-sort"></i></span></th>
                                                        <th class="min-w-150px"><span>Compétences</span></th>
                                                        <th class="min-w-125px"><span>Disponibilité<i
                                                                    (click)="sortData('availability')"
                                                                    class="fa-solid fa-sort"></i></span></th>
                                                        <th class="min-w-125px"><span>Pays<i (click)="sortData('city')"
                                                                    class="fa-solid fa-sort"></i></span></th>
                                                        <th class="min-w-125px"><span>Ville<i
                                                                    (click)="sortData('country')"
                                                                    class="fa-solid fa-sort"></i></span></th>
                                                        <th class="min-w-150px"><span>STATUT<i
                                                                    (click)="sortData('state')"
                                                                    class="fa-solid fa-sort"></i></span></th>
                                                        <th class="text-end min-w-70px"><span>Actions<i
                                                                    (click)="sortData('')"
                                                                    class="fa-solid fa-sort"></i></span></th>
                                                        <th class="min-w-90px">
                                                            <div class="dropdown" id="table-filter">
                                                                <button
                                                                    class="btn btn-sm  btn-flex btn-centerdropdown-toggle"
                                                                    type="button" id="dropdownMenuButton"
                                                                    data-bs-toggle="dropdown" aria-haspopup="true"
                                                                    aria-expanded="false">
                                                                    <svg width="28" height="28" viewBox="0 0 28 28"
                                                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <g filter="url(#filter0_d_444_2002)">
                                                                            <rect x="4" width="20" height="20" rx="4"
                                                                                fill="#63C3E8" fill-opacity="0.12"
                                                                                shape-rendering="crispEdges" />
                                                                        </g>
                                                                        <path
                                                                            d="M17.5 10.6H14.6V13.5C14.6 13.8314 14.3314 14.1 14 14.1C13.6686 14.1 13.4 13.8314 13.4 13.5V10.6H10.5C10.1686 10.6 9.9 10.3314 9.9 10C9.9 9.66863 10.1686 9.4 10.5 9.4H13.4V6.5C13.4 6.16863 13.6686 5.9 14 5.9C14.3314 5.9 14.6 6.16863 14.6 6.5V9.4H17.5C17.8314 9.4 18.1 9.66863 18.1 10C18.1 10.3314 17.8314 10.6 17.5 10.6Z"
                                                                            fill="#265D91" stroke="#265D91"
                                                                            stroke-width="0.2" />
                                                                        <defs>
                                                                            <filter id="filter0_d_444_2002" x="0" y="0"
                                                                                width="28" height="28"
                                                                                filterUnits="userSpaceOnUse"
                                                                                color-interpolation-filters="sRGB">
                                                                                <feFlood flood-opacity="0"
                                                                                    result="BackgroundImageFix" />
                                                                                <feColorMatrix in="SourceAlpha"
                                                                                    type="matrix"
                                                                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                                                    result="hardAlpha" />
                                                                                <feOffset dy="4" />
                                                                                <feGaussianBlur stdDeviation="2" />
                                                                                <feComposite in2="hardAlpha"
                                                                                    operator="out" />
                                                                                <feColorMatrix type="matrix"
                                                                                    values="0 0 0 0 0.14902 0 0 0 0 0.364706 0 0 0 0 0.568627 0 0 0 0.13 0" />
                                                                                <feBlend mode="normal"
                                                                                    in2="BackgroundImageFix"
                                                                                    result="effect1_dropShadow_444_2002" />
                                                                                <feBlend mode="normal"
                                                                                    in="SourceGraphic"
                                                                                    in2="effect1_dropShadow_444_2002"
                                                                                    result="shape" />
                                                                            </filter>
                                                                        </defs>
                                                                    </svg>
                                                                </button>
                                                                <div class="dropdown-menu"
                                                                    aria-labelledby="dropdownMenuButton">
                                                                    <div
                                                                        class="form-check form-check-custom form-check-solid mb-3">
                                                                        <input class="form-check-input" type="checkbox"
                                                                            value="1" id="flexCheckDefault" checked />
                                                                        <label class="form-check-label"
                                                                            for="flexCheckDefault">
                                                                            POSTE
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        class="form-check form-check-custom form-check-solid mb-3">
                                                                        <input class="form-check-input" type="checkbox"
                                                                            value="1" id="flexCheckDefault" checked />
                                                                        <label class="form-check-label"
                                                                            for="flexCheckDefault">
                                                                            POSTE
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        class="form-check form-check-custom form-check-solid mb-3">
                                                                        <input class="form-check-input" type="checkbox"
                                                                            value="1" id="flexCheckDefault" checked />
                                                                        <label class="form-check-label"
                                                                            for="flexCheckDefault">
                                                                            COMPÉTENCES
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        class="form-check form-check-custom form-check-solid mb-3">
                                                                        <input class="form-check-input" type="checkbox"
                                                                            value="1" id="flexCheckDefault" checked />
                                                                        <label class="form-check-label"
                                                                            for="flexCheckDefault">
                                                                            ANS.EXP
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        class="form-check form-check-custom form-check-solid mb-3">
                                                                        <input class="form-check-input" type="checkbox"
                                                                            value="1" id="flexCheckDefault" checked />
                                                                        <label class="form-check-label"
                                                                            for="flexCheckDefault">
                                                                            SALAIRE
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        class="form-check form-check-custom form-check-solid mb-3">
                                                                        <input class="form-check-input" type="checkbox"
                                                                            value="1" id="flexCheckDefault" checked />
                                                                        <label class="form-check-label"
                                                                            for="flexCheckDefault">
                                                                            TJM
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        class="form-check form-check-custom form-check-solid mb-3">
                                                                        <input class="form-check-input" type="checkbox"
                                                                            value="1" id="flexCheckDefault" checked />
                                                                        <label class="form-check-label"
                                                                            for="flexCheckDefault">
                                                                            VILLE
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        class="form-check form-check-custom form-check-solid mb-3">
                                                                        <input class="form-check-input" type="checkbox"
                                                                            value="1" id="flexCheckDefault" checked />
                                                                        <label class="form-check-label"
                                                                            for="flexCheckDefault">
                                                                            VILLE
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        class="form-check form-check-custom form-check-solid mb-3">
                                                                        <input class="form-check-input" type="checkbox"
                                                                            value="1" id="flexCheckDefault" checked />
                                                                        <label class="form-check-label"
                                                                            for="flexCheckDefault">
                                                                            DATE
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        class="form-check form-check-custom form-check-solid mb-3">
                                                                        <input class="form-check-input" type="checkbox"
                                                                            value="1" id="flexCheckDefault" checked />
                                                                        <label class="form-check-label"
                                                                            for="flexCheckDefault">
                                                                            DÉDIÉ AU
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        class="form-check form-check-custom form-check-solid mb-3">
                                                                        <input class="form-check-input" type="checkbox"
                                                                            value="1" id="flexCheckDefault" checked />
                                                                        <label class="form-check-label"
                                                                            for="flexCheckDefault">
                                                                            TYPE POSTE
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        class="form-check form-check-custom form-check-solid mb-3">
                                                                        <input class="form-check-input" type="checkbox"
                                                                            value="1" id="flexCheckDefault" checked />
                                                                        <label class="form-check-label"
                                                                            for="flexCheckDefault">
                                                                            STATUT
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        class="form-check form-check-custom form-check-solid mb-3">
                                                                        <input class="form-check-input" type="checkbox"
                                                                            value="1" id="flexCheckDefault" checked />
                                                                        <label class="form-check-label"
                                                                            for="flexCheckDefault">
                                                                            Disponibilite
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody class="fw-semibold text-gray-600">
                                                    <tr *ngFor="let call of listCallOffers ;let i=index">
                                                        <td><span class="first-td"
                                                                 routerLink="/detail-offre/{{call.id}}">{{call.ID_jobRequest}}</span>
                                                        </td>
                                                        <td><span class="first-td"
                                                                 routerLink="/detail-offre/{{call.id}}">{{call.name}}</span>
                                                        </td>
                                                        <td>
                                                            <span>
                                                                {{ !call.start_date ? '---' : call.start_date.split('
                                                                ')[0].split('-').reverse().join('/') }}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span>{{call.years_of_experience}} ans</span>
                                                        </td>
                                                        <td>
                                                            <div *ngFor="let contractType of call.contract_type">
                                                                <span class="color-blue">{{ contratTypeOptions[contractType] }}</span>
                                                                 
                                                            </div>
                                                            <!-- <span *ngIf="call.contract_type.length===0">---</span>  -->

                                                        </td>
                                                        <td>
                                                            <!-- <span >{{call.salary? call.salary :'---'}} €</span> -->
                                                            <span *ngIf="call.salary && call.salary!==null && call.salary!=='null'">{{ call.salary +'&euro;'}}</span>
                                                            <span *ngIf="!call.salary || call.salary===null || call.salary==='null'">---</span>
                                                         </td>
                                                        <td>
                                                            <!-- <span>{{call.tjm ? call.tjm :'---'}} € </span> -->
                                                            <span *ngIf="call.tjm  && call.tjm!==null && call.tjm!=='null'">{{ call.tjm + '&euro;'}}</span>
                                                            <span *ngIf="!call.tjm || call.tjm===null || call.tjm==='null'">---</span>
                                                        </td>
                                                        <td>
                                                   
                                                            <span *ngIf="call.post_type==1"
                                                                class="badge badge-type hybride-badge">A distance</span>
                                                            <span *ngIf="call.post_type==2"
                                                                class="badge badge-type sur-site-badge">Hybride</span>
                                                            <span *ngIf="call.post_type==3"
                                                                class="badge badge-type teletravail-badge">Sur site</span>
                                                                <span *ngIf="call.post_type===null">---</span>


                                                        </td>
                                                        <td>
                                                            <div class="skills">
                                                                <ng-container
                                                                    *ngFor="let skill of call.skills_job.slice(0,2)">
                                                                    <span>
                                                                        <div class="php">
                                                                            {{skill?.sub_category?.name_FR?skill?.sub_category?.name_FR:'---'}}
                                                                        </div>
                                                                    </span>
                                                            

                                                                </ng-container>
                                                                <span
                                                                    *ngIf="call.skills_job?.length&&call.skills_job?.length>2"><svg
                                                                        width="8" height="8" viewBox="0 0 8 8"
                                                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path
                                                                            d="M7.34144 4.86849H4.51344V7.76649H3.02944V4.86849H0.201438V3.52449H3.02944V0.626487H4.51344V3.52449H7.34144V4.86849Z"
                                                                            fill="#ACA7A7" />
                                                                    </svg>
                                                                </span>
                                                            </div>
                                                        </td>
                                                        <td class="cle" *ngIf="!call.skills_job?.length">
                                                            <span class="key-word">
                                                                <div class="php"><svg width="6" height="6"
                                                                        viewBox="0 0 6 6" fill="none">
                                                                    </svg>---</div>
                                                            </span>
                                                        </td>


                                                        <td><span class="color-blue">{{
                                                                availabilituyTypeOptions[call.availability] }}</span>
                                                        </td>

                                                        <td><span>{{call.country}}</span></td>
                                                        <td><span>{{call.city}}</span></td>




                                                        <td *ngIf="call.state === 0">
                                                            <span class="actif">
                                                                <i class="fa-solid fa-circle"></i> Actif
                                                            </span>
                                                        </td>
                                                        <td *ngIf="call.state === 1">
                                                            <span class="badge desactif"> <i
                                                                    class="fa-solid fa-circle"></i> Non Actif</span>
                                                   
                                                        </td>
                                                        <td class="actions">
                                                            <div class="tools">
                                                                <div class="dropdown">
                                                                    <button
                                                                        class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                                                        type="button" id="dropdownMenuButton"
                                                                        data-bs-toggle="dropdown" aria-haspopup="true"
                                                                        aria-expanded="false">
                                                                        <svg width="19" height="5" viewBox="0 0 19 5"
                                                                            fill="none"
                                                                            xmlns="http://www.w3.org/2000/svg">
                                                                            <circle cx="2.44739" cy="2.44739"
                                                                                r="2.44739"
                                                                                transform="matrix(1 0 0 -1 0 4.89478)"
                                                                                fill="#265D91" />
                                                                            <circle cx="2.44739" cy="2.44739"
                                                                                r="2.44739"
                                                                                transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                                                fill="#265D91" />
                                                                            <circle cx="2.44739" cy="2.44739"
                                                                                r="2.44739"
                                                                                transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                                                fill="#265D91" />
                                                                        </svg>
                                                                    </button>
                                                                    <div class="dropdown-menu"
                                                                        aria-labelledby="dropdownMenuButton">
                                                                        <a class="dropdown-item "
                                                                             routerLink="/detail-offre/{{call.id}}"
                                                                            style="cursor: pointer;">Voir
                                                                            Détail</a>

                                                                        <a class="dropdown-item"
                                                                            (click)="openModal(modify_appel,call)"
                                                                            style="cursor: pointer;">
                                                                            Modifier
                                                                        </a>
                                                         

                                                                        <a class="dropdown-item"
                                                                            style="cursor: pointer;"
                                                                            routerLink="candidature-appel-offre/{{call.id}}">Liste
                                                                            des candidatures</a>
                                                                        <a class="dropdown-item" (click)="navigateToAddBareme(call.id)"
                                                                            style="cursor: pointer;">Voir barème </a>
                                                                        <a class="dropdown-item"
                                                                            style="cursor: pointer;" routerLink="/suggestion-call-offer/{{call.id}}">suggestion </a>
                                                                        <a class="dropdown-item"
                                                                            style="cursor: pointer;" routerLink="list-esn-call-offer/{{call.id}}">Qui a visualiser
                                                                            cette offre </a>
                                                                            <a *ngIf="call.state==1" class="dropdown-item cursor-pointer"
                                                                            (click)="activerjoboffer(call.id)">Activer</a>
                                                                        <a *ngIf="call.state==0" class="dropdown-item cursor-pointer"
                                                                            (click)="desactiverjoboffer(call.id)">Désactiver</a>


                                                                    </div>
                                                                </div>






                                                            </div>
                                                        </td>
                                                    </tr>

                                                </tbody>
                                            </table>

                                            <!--end::Table-->
                                        </div>


                                        <!--end::Card body-->
                                    </div>
                                    <div class="alert alert-warning text-center mt-5" role="alert"
                                        *ngIf="listCallOffers && !listCallOffers.length">
                                        <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
                                        <span class="empty-list">
                                            La liste est vide
                                        </span>
                                    </div>
                                </div>

                                <!--end::Tab pane-->
                            </div>

                            <!--end::Table-->
                        </div>
                        <!--end::Card body-->
                    </div>
                    <!--end::Card-->

                    <div class="pagination" *ngIf="listCallOffers&& listCallOffers.length">
                        <app-pagination [data]="listCallOffers" [lengthData]="totalItems" [currentPageList]="currentPage" [endexPageList]="endIndex" (setPages)="getItems($event)">
                        </app-pagination>
                    </div>
      
                </div>
                <!--end::Content container-->

            </div>

            <!--end::Content-->
        </div>
        <!--end::Content wrapper-->
        <!--begin::Footer-->

        <!--end::Footer-->
        <!--end:::Main-->
    </div>

    <div class="modal fade" id="add-appel" tabindex="-1" aria-hidden="true">
        <!--begin::Modal dialog-->
        <div class="modal-dialog modal-dialog-centered mw-650px">
            <!--begin::Modal content-->
            <div class="modal-content pt-5  pb-15">
                <!--begin::Modal header-->
                <div class="modal-header">
                    <!--begin::Modal title-->
                    <h2 class="fw-bold">Ajouter appel d'offre</h2>
                    <!--end::Modal title-->
                    <!--begin::Close-->
                    <div id="kt_customers_export_close" class="btn btn-icon btn-sm btn-active-icon-primary"
                        data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()">
                        <i class="ki-duotone ki-cross fs-1">
                            <span class="path1"></span>
                            <span class="path2"></span>
                        </i>
                    </div>
                    <!--end::Close-->
                </div>
                <!--end::Modal header-->
                <!--begin::Modal body-->
                <form [formGroup]="createform">

                    <div class="modal-body mx-5 my-7">
                        <!--begin::Form-->
                        <div class="container">


                            <div class="card-body">
                                <div class="row">

                                    <div class="col-lg-6 tools mb-5">
                                     <div class="mb-5">
                                        <label for="poste" class="required form-label">Poste</label>

                                        <input type="text" formControlName="name" id="poste" class="form-control mb-3"
                                            placeholder="Poste">
                                        <app-feild-error [control]="createform.get('name')"
                                            [controlName]="'name'"></app-feild-error>
                                     </div>

                                            <div class="mb-5">
                                                <label for="poste">Type de poste</label>

                                                <ng-select formControlName="post_type" [items]="postType" bindLabel="name"
                                                    bindValue="id" [placeholder]="'Type de poste'" autoComplete>
                                                </ng-select>
                                            </div>
                                            <div class="mb-5">
                                                <label for="poste">TJM</label>
                                                <input type="number" min="0" oninput="validity.valid||(value='0');" name="TJM"
                                                    id="TJM" class="form-control mb-3" formControlName="tjm" placeholder="TJM">
                                                <div *ngIf="createform.get('tjm')?.value && !isNumeric(createform.get('tjm')?.value)"
                                                    class="text-danger">
                                                    <small>Le champ "tjm" doit être un nombre</small>
                                                </div>
                                            </div>
                                            <div class="mb-5">
                                                <label for="poste" class="required form-label">Pays</label>
                                                <ng-select (change)="onCountryChange('add')" [items]="paysList"
                                                    formControlName="country" bindLabel="name" bindValue="name"
                                                    [placeholder]="'Pays destinataire'" autoComplete>
                                                </ng-select>
                                                <div *ngIf="createform.get('country')?.hasError('required') && createform.get('country')?.touched"
                                                    class="text-danger">
                                                   <small> Le champ "Pays" est obligatoire</small>
                                                </div>
                                            </div>
                                            <div class="mb-5">
                                                <label for="poste" class="required form-label">Compétences</label>
                                                <ng-select [items]="skillsList" bindLabel="name_FR" formControlName="skills"
                                                    class="form-select mb-3" placeholder="Compétences" 
                                                    [multiple]="true">
                                                </ng-select>
                                                <div *ngIf="createform.get('skills')?.hasError('required') && createform.get('skills')?.touched"
                                                    class="text-danger">
                                                   <small> Le champ "compétence" est obligatoire</small>
                                                </div>
                                            </div>
                                            <div class="mb-5">
                                                <label for="poste">Disponibilité</label>

                                                <ng-select formControlName="availability" [items]="disponibilite"
                                                    bindLabel="name" bindValue="id" [placeholder]="'Disponibilité'"
                                                    autoComplete>
                                                </ng-select>
                                            </div>

                                    </div>
                                    <div class="col-lg-6 tools mb-5">
                                        <div class="mb-5">
                                            <label for="poste" class="required form-label">Année d'éxperience</label>
                                        <input type="number" min="0" oninput="validity.valid||(value='0');" name="annee"
                                            id="annee" formControlName="years_of_experience"
                                            placeholder="Années d'experience en ans " class="form-control mb-3">
                                        <div *ngIf="createform.get('years_of_experience')?.hasError('required') && createform.get('years_of_experience')?.touched"
                                            class="text-danger">
                                           <small> Le champ "Année d'éxperience" est obligatoire</small>
                                        </div>
                                        </div>
                                        <div class="mb-5">
                                            
                                            <label for="poste">Type de contrat</label>
                                            <ng-select placeholder="Type de contrat" data-hide-search="true" name="format"
                                                formControlName="contract_type" class="form-select mb-3" [multiple]="true" [notFoundText]="'Aucun élément trouvé'">
                                                <ng-option *ngFor="let contractType of contractTypesList"
                                                    [value]="contractType.id">{{ contractType.name }}</ng-option>
                                            </ng-select>
                                        </div>
                                        <div class="mb-5">
                                            <label for="poste">Salaire</label>
                                            <input type="number" min="0" oninput="validity.valid||(value='0');"
                                                name="salary" id="salary" formControlName="salary" class="form-control mb-3"
                                                placeholder="Salaire">
                                  
                                            <div *ngIf="createform.get('salary')?.value && !isNumeric(createform.get('salary')?.value)"
                                                class="text-danger">
                                               <small> Le champ "Salaire" doit être un nombre</small>
                                            </div>
                                        </div>
                                        <div class="mb-5">
                                            <label for="poste">Ville</label>
                                            <ng-select [items]="stateList" [ngClass]="{'disable-select':!stateList?.length}" [attr.disabled]="!stateList?.length ? true : null" bindLabel="name" formControlName="city" [multiple]="true"
                                                bindValue="name" [placeholder]="'City'" (change)="onMobilityChange('add')" autoComplete>
                                            </ng-select>
                                        </div>
                                        <div class="mb-5">
                                            <label for="poste"> Autres Compétences</label>
                                    
                                            <input type="text" formControlName="otherSkills" id="poste"
                                                class="form-control mb-3" placeholder="Autres Compétences">
                                            <div *ngIf="createform.get('otherSkills')?.hasError('required') && createform.get('otherSkills')?.touched"
                                                class="text-danger">
                                               <small> Le champ "Autres compétence" est obligatoire</small>
                                            </div>
                                        </div>
                                    </div>
                                 

                                   
                                  
                                   


                                </div>
                               <div class="choix mb-5">
                                <div class="form-check">
                                    <input class="form-check-input" formControlName="profile_abroad" type="checkbox"
                                        value="" id="flexCheckChecked" checked />
                                    <label class="form-check-label" for="flexCheckChecked">
                                        Possibilité profil à étranger ( intégration)
                                    </label>

                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value=""
                                        formControlName="passeport_talent" id="flexCheckChecked1" checked />
                                    <label class="form-check-label" for="flexCheckChecked1">
                                        Passeport talent
                                    </label>
                                </div>
                               </div>
                               
                               <div class="form-check form-check-custom form-check-solid">
                                <input class="form-check-input" type="checkbox" id="flexCheckDefault" [disabled]="true" [checked]="false" />
                                <label class="form-check-label" for="flexCheckDefault">Dédié au particulier</label>
                                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                <input class="form-check-input ml-2" formControlName="dedicated_to" type="checkbox" id="flexCheckDefault2" />
                                <label class="form-check-label ml-2" for="flexCheckDefault2">Dédié aux ESN</label>
                            </div>
                            
                                <div class="row">
                                    <div class="desc tools mb-5">
                                        <label for="poste" class="form-label mb-3"> Description</label>

                                        <quill-editor formControlName="description" [modules]="{ toolbar: toolbarOptions }"
                                            style="width: 100%; height: 200px;"
                                            (onContentChanged)="onContentChange($event)"
                                            ></quill-editor>
                                    </div>
                                </div>

                              

                            </div>
                        </div>

                    </div>
                  
                    <div class="card-footer text-center">
                        <div class="actions">
                           <br>
                           <br>
                            <a class="annuler" data-bs-dismiss="modal" aria-label="Close"
                                (click)="closeModal()">Annuler</a>
                            <a class="confirmer" data-bs-dismiss="modal" (click)="ajoutProfilecalloffer()" >Confirmer</a>


                        </div>
                    </div>

                </form>

                <!--end::Modal body-->
            </div>
            <!--end::Modal content-->
        </div>
        <!--end::Modal dialog-->
    </div>
    <ng-template #modify_appel>
    
                <div class="modal-dialog-centered" id="modify-appel" tabindex="-1" aria-hidden="true">
                    <div class="modal-content pt-5  pb-15">
                <!--begin::Modal content-->
                <div class=" pt-5  pb-15">
                    <!--begin::Modal header-->
                    <div class="modal-header">
                        <!--begin::Modal title-->
                        <h2 class="fw-bold">Modifier appel d'offre</h2>
                        <!--end::Modal title-->
                        <!--begin::Close-->
                        <div id="kt_customers_export_close" class="btn btn-icon btn-sm btn-active-icon-primary"
                            data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()">
                            <i class="ki-duotone ki-cross fs-1">
                                <span class="path1"></span>
                                <span class="path2"></span>
                            </i>
                        </div>
                        <!--end::Close-->
                    </div>
                    <!--end::Modal header-->
                    <!--begin::Modal body-->
                    <form [formGroup]="createform">

                        <div class="modal-body mx-5 my-7">
                            <!--begin::Form-->
                            <div class="container">
    
    
                                <div class="card-body">
                                    <div class="row">
    
                                        <div class="col-lg-6 tools mb-5">
                                         <div class="mb-5">
                                            <label for="poste" class="required form-label">Poste</label>
    
                                            <input type="text" formControlName="name" id="poste" class="form-control mb-3"
                                                placeholder="Poste">
                                            <app-feild-error [control]="createform.get('name')"
                                                [controlName]="'name'"></app-feild-error>
                                         </div>
    
                                                <div class="mb-5">
                                                    <label for="poste">Type de poste</label>
    
                                                    <ng-select formControlName="post_type" [items]="postType" bindLabel="name"
                                                        bindValue="id" [placeholder]="'Type de poste'" autoComplete>
                                                    </ng-select>
                                                </div>
                                                <div class="mb-5">
                                                    <label for="poste">TJM</label>
                                                    <input type="number" min="0" oninput="validity.valid||(value='0');" name="TJM"
                                                        id="TJM" class="form-control mb-3" formControlName="tjm" placeholder="TJM">
                                                    <div *ngIf="createform.get('tjm')?.value && !isNumeric(createform.get('tjm')?.value)"
                                                        class="text-danger">
                                                        <small>Le champ "tjm" doit être un nombre</small>
                                                    </div>
                                                </div>
                                                <div class="mb-5">
                                                    <label for="poste" class="required form-label">Pays</label>
                                               
                                                    <ng-select (change)="onCountryChange1('add')" [items]="paysList" [multiple]="true"
                                        id="pays_destinataire" bindLabel="name" bindValue="name" [placeholder]="'Pays *'"
                                        autoComplete formControlName="country"  [notFoundText]="'Aucun élément trouvé'" >
                                        <ng-template ng-optgroup-tmp let-item="item">
                                          {{ item.name || "Unnamed group" }}
                                        </ng-template>
                                      </ng-select>
                                                    <div *ngIf="createform.get('country')?.hasError('required') && createform.get('country')?.touched"
                                                        class="text-danger">
                                                       <small> Le champ "Pays" est obligatoire</small>
                                                    </div>
                                                </div>
                                                <div class="mb-5">
                                                    
                                                    <label for="poste" class="form-label">Compétences</label>
                                                    <ng-select [items]="skillsList" bindLabel="name_FR" bindValue="id"
                                                    formControlName="skills" [multiple]="true" id="skillsList"
                                                    [placeholder]="'Compétences'" autoComplete>
                                                </ng-select>
                                         
                                                    <!-- <div *ngIf="createform.get('skills')?.hasError('required') && createform.get('skills')?.touched"
                                                        class="text-danger">
                                                       <small> Le champ "compétence" est obligatoire</small>
                                                    </div> -->
                                                </div>
                                                <div class="mb-5">
                                                    <label for="poste">Disponibilité</label>
    
                                                    <ng-select formControlName="availability" [items]="disponibilite"
                                                        bindLabel="name" bindValue="id" [placeholder]="'Disponibilité'"
                                                        autoComplete>
                                                    </ng-select>
                                                </div>
    
                                        </div>
                                        <div class="col-lg-6 tools mb-5">
                                            <div class="mb-5">
                                                <label for="poste" class="required form-label">Année d'éxperience</label>
                                            <input type="number" min="0" oninput="validity.valid||(value='0');" name="annee"
                                                id="annee" formControlName="years_of_experience"
                                                placeholder="Années d'experience en ans " class="form-control mb-3">
                                            <div *ngIf="createform.get('years_of_experience')?.hasError('required') && createform.get('years_of_experience')?.touched"
                                                class="text-danger">
                                               <small> Le champ "Année d'éxperience" est obligatoire</small>
                                            </div>
                                            </div>
                                            <div class="mb-5">
                                                <label for="poste">Type de contrat</label>
                                                <ng-select placeholder="Type de contrat" data-hide-search="true" name="format"
                                                    formControlName="contract_type" class="form-select mb-3" [multiple]="true" [notFoundText]="'Aucun élément trouvé'">
                                                    <ng-option *ngFor="let contractType of contractTypesList"
                                                        [value]="contractType.id">{{ contractType.name }}</ng-option>
                                                </ng-select>
                                            </div>
                                            <div class="mb-5">
                                                <label for="poste">Salaire</label>
                                                <input type="number" min="0" oninput="validity.valid||(value='0');"
                                                    name="salary" id="salary" formControlName="salary" class="form-control mb-3"
                                                    placeholder="Salaire">
                                         
                                                <div *ngIf="createform.get('salary')?.value && !isNumeric(createform.get('salary')?.value)"
                                                    class="text-danger">
                                                   <small> Le champ "Salaire" doit être un nombre</small>
                                                </div>
                                            </div>
                                            <div class="mb-5">
                                                <label for="poste">Ville</label>
                                                <ng-select  [items]="stateList" [ngClass]="{'disable-select':!stateList?.length}" [attr.disabled]="!stateList?.length ? true : null" [multiple]="true"
                                                (change)="onMobilityChange('add')" id="mobilite" bindLabel="name"
                                                formControlName="city" 
                                                [notFoundText]="'Aucun élément trouvé'" bindValue="name" [placeholder]="'Ville '" autoComplete>
                                                </ng-select>
                                            </div>
                                            <div class="mb-5">
                                                <label for="poste"> Autres Compétences</label>
                                            
                                                <input type="text" formControlName="otherSkills" id="poste"
                                                    class="form-control mb-3" placeholder="Autres Compétences">
                                                <div *ngIf="createform.get('otherSkills')?.hasError('required') && createform.get('otherSkills')?.touched"
                                                    class="text-danger">
                                                   <small> Le champ "Autres compétence" est obligatoire</small>
                                                </div>
                                            </div>
                                        </div>
                                   
    
                                       
                                      
                                       
    
    
                                    </div>
                                   <div class="choix mb-5">
                                    <div class="form-check">
                                        <input class="form-check-input" formControlName="profile_abroad" type="checkbox"
                                            value="" id="flexCheckChecked" checked />
                                        <label class="form-check-label" for="flexCheckChecked">
                                            Possibilité profil à étranger ( intégration)
                                        </label>
    
                                    </div>
                                    
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value=""
                                            formControlName="passeport_talent" id="flexCheckChecked1" checked />
                                        <label class="form-check-label" for="flexCheckChecked1">
                                            Passeport talent
                                        </label>
                                    </div>
                                   </div>
                                    <div class="row">
                                        <div class="desc tools mb-5">
                                            <label for="poste" class="form-label mb-3 required"> Description</label>

                                            <quill-editor formControlName="description" [modules]="{ toolbar: toolbarOptions }"
                                                style="width: 100%; height: 200px;"
                                                (onContentChanged)="onContentChange($event)"
                                                ></quill-editor>
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                        </div>
                        <br>
                        <br>
                        <div class="card-footer text-center">
                            <div class="actions">
                                <a class="annuler" data-bs-dismiss="modal" aria-label="Close"
                                    (click)="closeModal()">Annuler</a>
                                <a class="confirmer" data-bs-dismiss="modal" (click)="updateCALLOFFER()">Confirmer</a>
    
    
                            </div>
                        </div>
    
                    </form>

                    <!--end::Modal body-->
                </div>
                <!--end::Modal content-->
            </div>
            <!--end::Modal dialog-->
        </div>
    </ng-template>